import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid2,
  IconButton,
  Stack,
  Switch,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialButton from "../../../components/MaterialButton";
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../reducers/formReducer";
import MaterialSelect from "../../../components/MasterSelect";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const initialState = {
  generalPreviousInsurer: {},
  generalPreviousInsurerErr: "unchecked",
  generalInsurer: {},
  generalInsurerErr: "unchecked",
  bussinessType: {},
  bussinessTypeErr: "unchecked",
  code: "",
  codeErr: "unchecked",
  name: "",
  nameErr: "unchecked",
  active: true,
};

const InsurerPreviousFrom = () => {
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const [state, dispatch] = useReducer(handelChange, initialState);
  const [dropdown, setDropdown] = useState({
    insurer: [],
    bussiness: [
      {
        value: "tp",
        label: "TP",
      },
      {
        value: "rollover",
        label: "Rollover",
      },
    ],
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const Id = searchParams.get("id");
  const pageType = searchParams.get("pageType");

  const pageMode =
    pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

  useEffect(() => {
    const fetchInsurerList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(
          `/reference/general/insurer-master?dropdown=true`
        );

        setDropdown((prev) => ({
          ...prev,
          insurer: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.companyName,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    };

    fetchInsurerList();
  }, []);

  useEffect(() => {
    const fetchCountryById = async () => {
      setCircleLoading(true);
      try {
        const data = await fetchDataById(`/reference/insurer/previous-insurer/${Id}`);
        const responseData = data?.data;

        if (data?.success) {
          dispatch({
            type: "bulkUpdate",
            payload: {
              generalPreviousInsurer: {
                value: responseData?.gPrevInsId,
                label: responseData?.gPrevInsurerName,
              },

              generalInsurer: {
                value: responseData?.gInsurerId,
                label: responseData?.gInsurerName,
              },
              insurerState: {
                value: responseData?.country?.id,
                label: responseData?.country?.name,
              },
              bussinessType: {
                value: responseData?.businessType,
                label: responseData?.businessType == "tp" ? "TP" : "Rollover",
              },

              code: responseData?.code,
              name: responseData?.prevInsurerName,
              active: responseData?.isActive,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching data by ID:", error);
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    };
    if (Id) {
      fetchCountryById();
    }
  }, [Id]);

  const handelSubmit = async () => {
    const payload = {
      gInsurerId: state?.generalInsurer?.value,
      gPrevInsId: state?.generalPreviousInsurer?.value,
      code: state?.code,
      prevInsurerName: state?.name,
      businessType: state?.bussinessType?.value,
      isActive: state?.active,
    };
    if (pageMode === "edit") {
      try {
        setCircleLoading(true);
        const response = await putData(
          `/reference/insurer/previous-insurer/${Id}`,
          payload
        );
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          navigate("/insurer-master/insurer-previous-insurer");
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    } else {
      try {
        setCircleLoading(true);
        const response = await postData("/reference/insurer/previous-insurer", payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          navigate("/insurer-master/insurer-previous-insurer");
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;

    if (
      state.bussinessTypeErr === "success" &&
      state.generalInsurerErr === "success" &&
      state.generalPreviousInsurerErr === "success" &&
      state.codeErr === "success" &&
      state.nameErr === "success"
    ) {
      allowSubmit = false;
    } else {
      allowSubmit = true;
    }

    return allowSubmit;
  };
  return (
    <>
      <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton
                    onClick={() =>
                      navigate("/insurer-master/insurer-previous-insurer")
                    }
                  >
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Previous Insurer Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New Previous Insurer Details from around the world.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
          />

          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    General Insurer <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="generalInsurer"
                  options={dropdown?.insurer}
                  value={state?.generalInsurer}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "generalInsurer",
                    })
                  }
                  success={state?.generalInsurerErr === "success"}
                  error={state.generalInsurerErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    General Previous Insurer <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.insurer}
                  value={state?.generalPreviousInsurer}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "generalPreviousInsurer",
                    })
                  }
                  success={state?.generalPreviousInsurerErr === "success"}
                  error={state.generalPreviousInsurerErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Bussiness Type <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.bussiness}
                  value={state?.bussinessType}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "bussinessType",
                    })
                  }
                  success={state?.bussinessTypeErr === "success"}
                  error={state?.bussinessTypeErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Code <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="code"
                  value={state?.code}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "code",
                      type: "input",
                      regex: "^([\\s\\S]{1,20})$",
                    })
                  }
                  success={state?.codeErr === "success"}
                  error={state.codeErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.codeErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Code should be a minimum 1 character & maximum 20
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Name <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  value={state?.name}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "name",
                      type: "input",
                      regex: "^([\\s\\S]{1,60})$",
                    })
                  }
                  success={state?.nameErr === "success"}
                  error={state.nameErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.nameErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be a minimum 1 character & maximum 60
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Active
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={state?.active}
                      onChange={() =>
                        dispatch({
                          type: "switch",
                          name: "active",
                          value: !state?.active,
                        })
                      }
                      color="primary"
                      disabled={pageMode === "view"}
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {state?.active ? "Active" : "Inactive"}
                    </MaterialTypography>
                  }
                  sx={{ marginLeft: 0 }}
                />
              </Grid2>
            </Grid2>
          </CardContent>
          <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {pageMode !== "view" && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="outlined"
                  color="dark"
                  onClick={() =>
                    navigate("/insurer-master/insurer-previous-insurer")
                  }
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={checkAllFields()}
                  onClick={handelSubmit}
                >
                  {pageMode === "add" ? "Submit" : "Update"}
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </Card>
      </DashboardLayout>
      <DashboardFooter />
    </>
  );
};

export default InsurerPreviousFrom;
